import { positionActionConstants } from 'tods-competition-factory';

import { type ParticipantInterface, type SideInterface } from 'typedefs/store/tmxTypes';
import { formatPlayerName } from 'utils/participant';

export interface PayloadParticipant {
  method: string;
  payload: any;
  type: string;
  participant: ParticipantInterface;
  existingIndividualParticipant?: ParticipantInterface;
}

const { ASSIGN_PARTICIPANT, LUCKY_PARTICIPANT, QUALIFYING_PARTICIPANT, MODIFY_PAIR_ASSIGNMENT } =
  positionActionConstants;

export const getPayloadParticipants = (payload: any) =>
  Array.from(payload || [])
    .map((p: any): PayloadParticipant[] => {
      if (p.type === QUALIFYING_PARTICIPANT) {
        return p.qualifyingParticipants.map((participant) => ({
          method: p.method,
          payload: p.payload,
          type: 'Selected',
          participant,
        }));
      }

      if (p.type === LUCKY_PARTICIPANT) {
        return p.availableLuckyLosers.map((participant) => ({
          method: p.method,
          payload: p.payload,
          type: 'Selected',
          participant,
        }));
      }

      if (p.type === ASSIGN_PARTICIPANT) {
        return p.participantsAvailable.map((participant) => ({
          method: p.method,
          payload: p.payload,
          type: 'Selected',
          participant,
        }));
      }

      if (p.type === MODIFY_PAIR_ASSIGNMENT) {
        return p.availableIndividualParticipants.map((participant, index) => ({
          method: p.method,
          payload: p.payload,
          type: 'Selected',
          participant: {
            ...participant,
            index: index + 1,
          },
        }));
      }

      return [];
    })
    .flat()
    .filter(Boolean);

export const getMatchUptSideFromDrawPosition = (matchUpSides: SideInterface[], drawPosition: number): SideInterface =>
  matchUpSides?.find((s) => s.drawPosition === drawPosition);

export const getSelectDoublesPlayerRadioOptions = (doublesParticipants: ParticipantInterface[]) =>
  doublesParticipants?.map((p) => ({
    value: p.participantId,
    label: p.person ? formatPlayerName(p.person?.standardGivenName, p.person?.standardFamilyName) : p.participantName,
  })) || [];
